import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/common/Button';
import { HomeIcon } from '@heroicons/react/24/outline';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary-600">404</h1>
        <h2 className="mt-4 text-3xl font-semibold text-gray-900">
          Page not found
        </h2>
        <p className="mt-2 text-gray-600">
          Sorry, we couldn't find the page you're looking for.
        </p>
        <Button
          variant="primary"
          leftIcon={<HomeIcon className="h-5 w-5" />}
          className="mt-8"
          onClick={() => navigate('/')}
        >
          Go back home
        </Button>
      </div>
    </div>
  );
}

export default NotFoundPage;
